import classes from "./MaintenancePage.module.css";
import { useTranslation } from "react-i18next";
import esperiLogo from "../../images/esperiLogo.png";

const MaintenancePage = () => {
  const { t } = useTranslation();

  return (
    <div className={classes.pageContainer}>
      <img
        src={esperiLogo}
        alt="Esperi Logo"
        style={{ marginBottom: "30px", width: "200px" }}
      />
      <h1 className={classes.title}>{t("maintenancePage.title")}</h1>
      <p className={classes.message}>{t("maintenancePage.message")}</p>
      <p className={classes.returnSoon}>{t("maintenancePage.returnSoon")}</p>
    </div>
  );
};

export default MaintenancePage;
